export * from './baKameleonPicture.pipe';



// WEBPACK FOOTER //
// ./src/app/theme/pipes/baKameleonPicture/index.ts